<template functional>
  <svg :class="[data.class, data.staticClass, 'stella-icon']" :style="data.staticStyle" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path v-if="props.filled" d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill="currentColor"/>
    <path v-else d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM4 6H20V8H4V6ZM20 18H4V12H20V18Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconBilling",
  props: {
    filled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
